import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '@fc-shared/ui/buttons/button.component';
import { DialogFullscreenToggleComponent } from '@fc-shared/ui/dialog-opener/dialog-fullscreen-toggle.component';
import { ModalBottomSheetRef } from '@fc-shared/ui/modal-bottom-sheet/modal-bottom-sheet-ref';

@Component({
  selector: 'fc-dialog-header',
  imports: [ButtonComponent, DialogFullscreenToggleComponent],
  template: `
    <div class="text-lg font-medium overflow-hidden text-ellipsis">
      {{ title() || '' }}
    </div>
    <div class="flex flex-row gap-8">
      @if (showFullscreenToggle()) {
        <fc-dialog-fullscreen-toggle />
      }
      <ng-content></ng-content>
      @if (showCloseButton()) {
        <fc-button variant="icon" (click)="closeDialog()" icon="icon-close" />
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'border-b border-secondary-100 flex justify-between items-center px-24 py-16 h-64',
  },
})
export class DialogHeaderComponent {
  private readonly dialogRef = inject(MatDialogRef, { optional: true });
  private readonly bottomSheetRef = inject(ModalBottomSheetRef, {
    optional: true,
  });
  title = input<string>();
  showCloseButton = input<boolean>(true);
  showFullscreenToggle = input<boolean>(false);
  preventClose = input<boolean>(false);
  onCloseClicked = output<void>();

  closeDialog() {
    this.onCloseClicked.emit();
    if (this.preventClose()) {
      return;
    }
    this.dialogRef?.close();
    this.bottomSheetRef?.dismiss();
  }
}
